<zn-button
  [label]="gisAreaLabel() | abpLocalization"
  [loadingLabel]="`${this.localizationResource}::Stand.GetGISAreaGetData` | abpLocalization"
  [loading]="gisAreaLoading()"
  [class.zn-button-success]="gisAreaStatus() === 'success'"
  [class.zn-button-error]="gisAreaStatus() === 'error'"
  loadingIconPosition="left"
  type="secondary"
  size="normal"
  iconLeft="bi bi-arrow-clockwise"
  [disabled]="!canFetchGisArea() || gisAreaStatus() !== 'default'"
  (clicked)="fetchGisArea()"
>
</zn-button>